import { useTranslation } from 'react-i18next';
import Navigation from '../components/Navigation';
import { Target } from '@phosphor-icons/react';

const PredictionsPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background" data-testid="predictions-page">
      <Navigation />
      <div className="max-w-3xl mx-auto px-6 lg:px-12 py-24 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 rounded-sm mb-6">
          <Target size={40} weight="bold" className="text-primary" />
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-white mb-4">
          {t('nav.predictions')}
        </h1>
        <div className="inline-block bg-[#FFD700] text-black font-bold uppercase tracking-widest text-sm px-6 py-2 rounded-sm mb-6">
          {t('dashboardPromo.comingSoon')}
        </div>
        <p className="text-text-secondary text-lg max-w-md mx-auto">
          {t('predictions.comingSoonDesc', 'Serie A 2026 predictions are coming soon. In the meantime, make your World Cup 2026 predictions!')}
        </p>
      </div>
    </div>
  );
};

export default PredictionsPage;
